export const DEFAULT_CLIENT_KEY = 'DEFAULT_CLIENT_KEY';